import { Footer } from "MODULES/shared/components/Modal";
import React from "react";
import { Cancel } from "MODULES/shared/components/Forms/AppForm";
import { Errors } from "MODULES/shared/components/Forms";

function Submit({
  disabled,
  isSubmitting,
  submitTimeout,
  onClick,
  text = "Save",
  submittingText = "Saving"
}) {
  return (
    <button
      onClick={onClick}
      disabled={disabled || isSubmitting || submitTimeout}
      type="submit"
      className="btn btn-primary"
    >
      {isSubmitting && <i className="fa fa-cog fa-spin fa-fw fa-lg" />}
      {isSubmitting ? ` ${submittingText}` : text}
    </button>
  );
}

function hasArrayOfErrors(obj) {
  if (typeof obj === "object" && obj !== null) {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in obj) {
      if (Array.isArray(obj[key]) && obj[key].length > 0) {
        return true;
      } else if (typeof obj[key] === "object" && obj[key] !== null) {
        if (hasArrayOfErrors(obj[key])) {
          return true;
        }
      }
    }
  }
  return false;
}

export function FormikFooter({
  disabled,
  editable,
  errorMessages,
  footer,
  handleSubmit,
  isSubmitting,
  setSubmitting,
  submitFailed,
  submitSucceeded,
  submitTimeout,
  close,
  values,
  rest
}) {
  let errors;
  if (submitTimeout) {
    errors = [
      "The request timed out. Please refresh page and check to see if expected records were updated before resubmitting."
    ];
  } else {
    errors = errorMessages;
  }

  return (
    <Footer>
      {(submitFailed || submitTimeout) && <Errors errors={errors} />}
      <Cancel close={close} editable={editable} />
      {footer}
      <Submit
        disabled={disabled || hasArrayOfErrors(rest.errors)}
        isSubmitting={isSubmitting}
        onClick={e => {
          e.preventDefault();
          setSubmitting(true);

          handleSubmit()
            .then(() => {
              setSubmitting(false);
              close();
            })
            .catch(() => {});
        }}
        values={values}
        submitSucceeded={submitSucceeded}
        submitTimeout={submitTimeout}
        editable={editable}
      />
    </Footer>
  );
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/FormikForm/FormikFooter.jsx